document.addEventListener("DOMContentLoaded", function () {
    // Insert modal HTML dynamically into the page
    const modalHTML = `
        <div id="product-modal" class="modal" style="display: none;">
            <div class="modal-content">
                <span class="close">&times;</span>
                <div id="modal-description"></div>
            </div>
        </div>
        <style>
            /* Basic Modal Styles */
            .modal { display: none; position: fixed; z-index: 1000; left: 0; top: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.5); }
            .modal-content { background: #fff; margin: 10% auto; padding: 20px; width: 80%; max-width: 400px; border-radius: 10px; text-align: center; }
        </style>
    `;
    document.body.insertAdjacentHTML("beforeend", modalHTML);

    const targetNode = document.querySelector(".block-wysiwyg");

    if (targetNode) {
        const observer = new MutationObserver((mutationsList, observer) => {
            mutationsList.forEach((mutation) => {
                if (mutation.type === "childList") {
                    const products = document.querySelectorAll(".shopify-buy__product");
                    products.forEach((product) => {
                        if (!product.getAttribute("click-set")) {
                            product.addEventListener("click", function (event) {
                                let target = event.target;

                                if (target.classList.contains("shopify-buy__buy-button") || target.closest(".shopify-buy__btn-wrapper")) {
                                    return; // Stop execution here
                                }

                                if (window.matchMedia("(max-width: 640px)").matches) {
                                    let productContainer = target.closest(".shopify-buy__product");

                                    let description = productContainer.querySelector(".shopify-buy__product-description");

                                    if (description) {
                                        let clonedDescription = description.cloneNode(true);

                                        let modalDescription = document.getElementById("modal-description");

                                        if (modalDescription) {
                                            modalDescription.innerHTML = "";
                                            modalDescription.appendChild(clonedDescription);

                                            document.getElementById("product-modal").style.display = "block";
                                        } else {
                                            console.warn("Modal description container not found!");
                                        }
                                    } else {
                                        console.warn("No description found in product.");
                                    }
                                }
                            });
                            product.setAttribute("click-set", "active");
                        }
                    });
                }
            });
        });

        // Configure the observer
        observer.observe(targetNode, {
            childList: true,
            subtree: true,
            characterData: true,
            attributes: true,
        });

        console.log("MutationObserver is running...");
    } else {
        console.error("Target element .block-wysiwyg not found");
    }

    // Close the modal when clicking the close button
    document.querySelector("body").addEventListener("click", function (event) {
        if (event.target.classList.contains("close")) {
            document.getElementById("product-modal").style.display = "none";
        }
    });

    // Close the modal when clicking outside of it
    window.addEventListener("click", function (event) {
        let modal = document.getElementById("product-modal");
        if (event.target === modal) {
            modal.style.display = "none";
        }
    });
});

//svg
document.addEventListener("DOMContentLoaded", function () {
    function isMobileView() {
        return window.matchMedia("(max-width: 640px)").matches;
    }

    const svgMarkup = `
        <div class="svg-overlay">
           <svg width="20px" height="20px" viewBox="-0.5 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 21.5C17.1086 21.5 21.25 17.3586 21.25 12.25C21.25 7.14137 17.1086 3 12 3C6.89137 3 2.75 7.14137 2.75 12.25C2.75 17.3586 6.89137 21.5 12 21.5Z" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12.9309 8.15005C12.9256 8.39231 12.825 8.62272 12.6509 8.79123C12.4767 8.95974 12.2431 9.05271 12.0008 9.05002C11.8242 9.04413 11.6533 8.98641 11.5093 8.884C11.3652 8.7816 11.2546 8.63903 11.1911 8.47415C11.1275 8.30927 11.1139 8.12932 11.152 7.95675C11.19 7.78419 11.278 7.6267 11.405 7.50381C11.532 7.38093 11.6923 7.29814 11.866 7.26578C12.0397 7.23341 12.2192 7.25289 12.3819 7.32181C12.5446 7.39072 12.6834 7.506 12.781 7.65329C12.8787 7.80057 12.9308 7.97335 12.9309 8.15005ZM11.2909 16.5301V11.1501C11.2882 11.0556 11.3046 10.9615 11.3392 10.8736C11.3738 10.7857 11.4258 10.7057 11.4922 10.6385C11.5585 10.5712 11.6378 10.518 11.7252 10.4822C11.8126 10.4464 11.9064 10.4286 12.0008 10.43C12.094 10.4299 12.1863 10.4487 12.272 10.4853C12.3577 10.5218 12.4352 10.5753 12.4997 10.6426C12.5642 10.7099 12.6143 10.7895 12.6472 10.8767C12.6801 10.9639 12.6949 11.0569 12.6908 11.1501V16.5301C12.6908 16.622 12.6727 16.713 12.6376 16.7979C12.6024 16.8828 12.5508 16.96 12.4858 17.025C12.4208 17.09 12.3437 17.1415 12.2588 17.1767C12.1738 17.2119 12.0828 17.23 11.9909 17.23C11.899 17.23 11.8079 17.2119 11.723 17.1767C11.6381 17.1415 11.5609 17.09 11.4959 17.025C11.4309 16.96 11.3793 16.8828 11.3442 16.7979C11.309 16.713 11.2909 16.622 11.2909 16.5301Z" fill="#000000"/>
            </svg>
        </div>
    `;

    const style = `
        <style>
            .svg-overlay {
                position: absolute;
                top: 5px;
                right: 5px;
                width: 25px;
                height: 25px;
                background: rgba(255, 255, 255, 0.86);
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                opacity: 1;
                transition: opacity 0.3s ease-in-out;
            }
            .shopify-buy__product-img-wrapper {
                position: relative;
                overflow: hidden;
            }
        </style>
    `;

    document.body.insertAdjacentHTML("beforeend", style);

    function injectSVGIcons() {
        if (isMobileView()) {
            document.querySelectorAll(".shopify-buy__product-img-wrapper").forEach((wrapper) => {
                if (!wrapper.querySelector(".svg-overlay")) {
                    wrapper.insertAdjacentHTML("beforeend", svgMarkup);
                }
            });
        } else {
            // Remove SVGs when screen is larger than 641px
            document.querySelectorAll(".svg-overlay").forEach((overlay) => {
                overlay.remove();
            });
        }
    }

    injectSVGIcons();

    const targetNode = document.querySelector(".block-wysiwyg");

    if (targetNode) {
        const observer = new MutationObserver(() => {
            injectSVGIcons();
        });

        observer.observe(targetNode, {
            childList: true,
            subtree: true,
        });
    } else {
        console.error("Target element .block-wysiwyg not found");
    }

    // Recheck on window resize to add/remove SVG
    window.addEventListener("resize", injectSVGIcons);
});
